import React, {useState} from "react";
import {Box, Button, Columns, Form} from "react-bulma-components";
import Collapsible from "react-collapsible";
import useInput from "../../../hooks/useInput";
import {useDispatch, useSelector} from "react-redux";
import {createSetDataFreshAction} from "../../../actions/dataActions";
import {getDataFresh} from "../../../state/selectors";
import axios from "axios";
import {NotificationManager} from "react-notifications";
import usePostWorkType from "../../../hooks/usePostWorkType";


export default function NewWorkType(props){
    const dispatch = useDispatch();
    let [name, nameInput, setName] = useInput({
        type: "text",
        label: "Name",
    });
    let [freeOfCharge, setFreeOfCharge] = useState(false);
    let [approval, setApproval] = useState(false);
    let [warrantyClaim, setWarrantyClaim] = useState(false);
    const [, postWorkType] = usePostWorkType({
        name: name,
        free_of_charge: freeOfCharge,
        approval_needed: approval,
        warranty_claim: warrantyClaim
    })
    const onClear = () => {
        setName("");
        setFreeOfCharge(false);
        setApproval(false);
    }


    const onFreeOfChargeCheck = e => {
        setFreeOfCharge(!freeOfCharge);
    };

    const onApprovalCheck = e => {
        setApproval(!approval);
    }

    const onWarrantyClaimCheck = e => {
        setWarrantyClaim(!warrantyClaim);
    }
    const onSave = () => {
        postWorkType().then(() => (
            onClear()
        ))
    }

    return(
        <Box className="settings_type">
            <Collapsible
                className={"title"}
                trigger={"Add Workshop Expense Charge Type"}
                triggerOpenedClassName={"title"}
            >
                <Columns>
                    {nameInput}
                    <Columns.Column>
                        <Form.Field>
                            <Form.Label>Free of Charge Work</Form.Label>
                            <Form.Checkbox
                                name={"free_of_charge"}
                                checked={freeOfCharge}
                                onChange={onFreeOfChargeCheck}
                            />
                        </Form.Field>
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Field>
                            <Form.Label>Approval Needed</Form.Label>
                            <Form.Checkbox
                                name={"approval_needed"}
                                checked={approval}
                                onChange={onApprovalCheck}
                            />
                        </Form.Field>
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Field>
                            <Form.Label>Should Claim for Warranty</Form.Label>
                            <Form.Checkbox
                                name={"warranty_claim"}
                                checked={warrantyClaim}
                                onChange={onWarrantyClaimCheck}
                            />
                        </Form.Field>
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <Button
                            color={"success"}
                            fullwidth
                            onClick={onSave}
                        >
                            Add
                        </Button>
                    </Columns.Column>
                </Columns>
            </Collapsible>
        </Box>
    )
}